import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core";
import { getAppName } from "@/lib/config.ts";
import SpacePublicSettings from "@/features/space/components/space-public-settings.tsx";

export default function SpacePublicSettingsPage() {
  const { t } = useTranslation();
  const { spaceId } = useParams<{ spaceId: string }>();

  if (!spaceId) return null;

  return (
    <>
      <Helmet>
        <title>
          {t("Public docs")} - {getAppName()}
        </title>
      </Helmet>
      {/* Break out of the settings Container(size=900) constraint so the
          preview iframe has room to breathe. */}
      <Box style={{ width: "100%" }}>
        <SpacePublicSettings spaceId={spaceId} />
      </Box>
    </>
  );
}
